import { useRef } from 'react'
import { StartEndDateSelectorProps } from '../../types/workflow.types'
import { WORKFLOW_STATUS } from '../../utils/constants'
import { STRINGS } from '../../utils/strings'
import { ROWS_TAB_DIFFERENCE_FOR_WORK_FOW } from '../../constants/form.constants'
import { isReadOnlyUser } from '../../utils/permission'
import TaskDatePicker from './TaskDatePicker'

const StartEndDateSelector: React.FC<StartEndDateSelectorProps> = ({
  task,
  overallCaseStatus,
  hasEditPermission,
  index,
}) => {
  const dueDate = useRef<string | Date>()
  const startDate = useRef<string | Date>()
  return (
    <>
      <span className="truncate">
        <TaskDatePicker
          task={task}
          dateType="start_date"
          isDisabled={
            isReadOnlyUser() ||
            (task?.standalone &&
            task?.state !== WORKFLOW_STATUS.CANCELLED &&
            task?.state !== WORKFLOW_STATUS.COMPLETED &&
            overallCaseStatus === STRINGS.CLOSED
              ? false
              : overallCaseStatus === STRINGS.CLOSED ||
                overallCaseStatus === STRINGS.VOID) ||
            !hasEditPermission(task)
          }
          tabIndex={ROWS_TAB_DIFFERENCE_FOR_WORK_FOW * (index + 1) + 1}
          max={dueDate.current ?? task.due_date}
          startDate={startDate}
          dueDate={dueDate}
        />
      </span>
      <span className="truncate">
        <TaskDatePicker
          task={task}
          dateType="due_date"
          isDisabled={
            isReadOnlyUser() ||
            (task?.standalone &&
            task?.state !== WORKFLOW_STATUS.CANCELLED &&
            task?.state !== WORKFLOW_STATUS.COMPLETED &&
            overallCaseStatus === STRINGS.CLOSED
              ? false
              : overallCaseStatus === STRINGS.CLOSED ||
                overallCaseStatus === STRINGS.VOID) ||
            !hasEditPermission(task)
          }
          tabIndex={ROWS_TAB_DIFFERENCE_FOR_WORK_FOW * (index + 1) + 1}
          min={startDate.current ?? task.start_date}
          startDate={startDate}
          dueDate={dueDate}
        />
      </span>
    </>
  )
}
export default StartEndDateSelector
